<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :confirm="askConfirm"
                    :params="{operationId: operationId, currentSection:0,operationBilanId:operationBilanId}"
                    :title="operation.name + ' - ' + $t('Operation.bilan')"
                    route-back="OperationShow"/>
      </div>
      <div class=" page-subtitle mt-2">{{ $t('operation.bilan.subtitle') }}</div>

      <steps-menu
        :current-step="currentStep"
        :last-active-step="lastActiveStep"
        :tab-menu="tabMenu"
        @stepChanged="stepChanged"/>

      <operation-bilan-charge-fonciere
        v-if="currentStep === 0"
        ref="chargeFonciere"
        :from-create-bilan="true"
        :operation-id="operationId"
        :is-h-t="isHT"
        :simulation-id="operation.simulationId"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinue="didContinue"
        @getOperationBilanId="getOperationBilanId"/>

      <operation-bilan-construction
        v-if="currentStep === 1"
        :is-h-t="isHT"
        ref="constructions"
        :operation-id="operationId"
        :simulation-id="operation.simulationId"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinue="didContinue"/>

      <operation-bilan-honoraires
        v-if="currentStep === 2"
        :ref="charges"
        :is-h-t="isHT"
        :operation-id="operationId"
        :simulation-id="operation.simulationId"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinue="didContinue"/>

      <operation-bilan-insurances
        v-if="currentStep === 3"
        ref="insurances"
        :is-h-t="isHT"
        :operation-id="operationId"
        :simulation-id="operation.simulationId"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinue="didContinue"/>

      <operation-bilan-frais-financiers
        v-if="currentStep === 4"
        ref="financiers"
        :is-h-t="isHT"
        :operation-id="operationId"
        :simulation-id="operation.simulationId"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinue="didContinue"/>

      <operation-bilan-total
        v-if="currentStep === 5"
        ref="total"
        :operation-id="operationId"
        :simulation-id="operation.simulationId"
        @didBack="didBack"
        @didChangeValue="didChangeValue"
        @didContinue="didContinue"/>

    </b-container>
  </div>

</template>

<script>

import StepsMenu from "../../components/b122/stepsMenu";
import i18n from '../../i18n'
import BackArrow from '../../components/b122/BackArrow'
import OperationBilanChargeFonciere from "./bilanCreateEditSteps/OperationBilanChargeFonciere";
import OperationBilanConstruction from "./bilanCreateEditSteps/OperationBilanConstruction";
import OperationBilanHonoraires from "./bilanCreateEditSteps/OperationBilanHonoraires";
import OperationBilanInsurances from "./bilanCreateEditSteps/OperationBilanInsurances";
import OperationBilanFraisFinanciers from "./bilanCreateEditSteps/OperationBilanFraisFinanciers";
import OperationBilanTotal from "./bilanCreateEditSteps/OperationBilanTotal";
import api from "../../services/api";

export default {

  name: "OperationBilanCreateEdit",

  components: {
    StepsMenu,
    i18n,
    BackArrow,
    OperationBilanChargeFonciere,
    OperationBilanConstruction,
    OperationBilanHonoraires,
    OperationBilanInsurances,
    OperationBilanFraisFinanciers,
    OperationBilanTotal
  },

  data() {
    return {
      currentStep: 0,
      operationId: this.$route.params.operationId,
      operationBilanId: this.$route.params.operationBilanId,
      operation: {
        name: null,
        simulationId: null
      },
      isHT:false,
      chargeFonciereDone: false,
      constructionDone: false,
      honorairesDone: false,
      assurancesDone: false,
      fraisFinanciersDone: false,
      askConfirm: false
    }
  },

  computed: {
    tabMenu() {
      return [
        i18n.t('operation.bilan.ChargeFonciere'),
        i18n.t('operation.bilan.Construction'),
        i18n.t('operation.bilan.Honoraires'),
        i18n.t('operation.bilan.Assurances'),
        i18n.t('operation.bilan.Frais.financiers'),
        i18n.t('operation.bilan.Total')]
    },

    lastActiveStep() {
      if (this.fraisFinanciersDone) {
        return 5
      } else if (this.assurancesDone) {
        return 4
      } else if (this.honorairesDone) {
        return 3
      } else if (this.constructionDone) {
        return 2
      } else if (this.chargeFonciereDone) {
        return 1
      } else {
        return 0
      }
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    fetchData() {
      if (this.operationId) {
        this.fetchOperation()
      }
      this.fetchOperationBilan()
    },

    fetchOperation() {
      api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operation.name = response.data.name
          this.isHT = response.data.isHT
          this.operation.simulationId = response.data.simulation.id
          if(this.operation.bilanId){
            this.operationBilanId = this.operation.bilanId
          }
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    fetchOperationBilan() {
      api
        .get(`/operation/getOperationBilan/${this.operationId}`)
        .then(response => {
          this.chargeFonciereDone = response.data.chargeFonciereDone
          this.constructionDone = response.data.constructionDone
          this.honorairesDone = response.data.honorairesDone
          this.assurancesDone = response.data.assurancesDone
          this.fraisFinanciersDone = response.data.fraisFinanciersDone
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    stepChanged(index) {
      this.currentStep = index
    },

    didBack() {
      this.currentStep--
      this.$nextTick(() => {
        this.successToast()
      })
    },

    incrementStep() {
      this.currentStep++
      this.$nextTick(() => {
        this.successToast()
      })
    },

    async didContinue(operationId, operationBilanId) {
      this.operationId = operationId
      this.operationBilanId = operationBilanId
      this.incrementStep()
    },

    async didChangeValue() {
      this.askConfirm = true
    },

    async getOperationBilanId(operationBilanId) {
      this.operationBilanId = operationBilanId
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('Operation.bilan') + ' ' + this.$i18n.t('registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/OperationBilanCreateEdit.vue